var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BoostStatus } from '../components/common/BoostStatus';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
let BoostPortalRegisterProfileSuccessView = class BoostPortalRegisterProfileSuccessView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    static get is() {
        return 'boost-portal-register-profile-success-view';
    }
    /** @override */ render() {
        return html ` <boost-portal-header></boost-portal-header>
            <boost-status type="success"> ${this.boostTranslate('created-user-success')} </boost-status>`;
    }
};
BoostPortalRegisterProfileSuccessView._deps = [BoostStatus, BoostPortalHeader];
BoostPortalRegisterProfileSuccessView = __decorate([
    customElement(BoostPortalRegisterProfileSuccessView.is)
], BoostPortalRegisterProfileSuccessView);
export { BoostPortalRegisterProfileSuccessView };
